import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9272718"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "users__inputs" }
const _hoisted_4 = { class: "flex justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dispatcher_sector_attach = _resolveComponent("dispatcher-sector-attach")!
  const _component_users_actions = _resolveComponent("users-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_users_list_item = _resolveComponent("users-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.attach_state.is_opened)
      ? (_openBlock(), _createBlock(_component_dispatcher_sector_attach, {
          key: 0,
          user: _ctx.attach_state.user,
          loading: _ctx.attach_state.is_loading,
          onCancel: _ctx.onCancelAttach,
          onSubmit: _ctx.onSubmitAttach
        }, null, 8, ["user", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_users_actions, {
          key: 1,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createUser,
          onUpdate: _ctx.updateUser,
          onDelete: _ctx.deleteUser,
          onCabinetUpdate: _ctx.onUpdateUserInCabinet
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete", "onCabinetUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Пользователи" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить пользователя ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("form", {
        class: "users__filters",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.loadUsers(1)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_input, {
            placeholder: "Поиск по Email",
            class: "w-full",
            value: _ctx.state.search,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.search) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            placeholder: "Поиск по имени",
            class: "w-full",
            value: _ctx.state.name,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.name) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            placeholder: "Поиск по телефону",
            class: "w-full",
            value: _ctx.state.phone,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.phone) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_the_select, {
            "can-deselect": "",
            class: "w-full mt-2",
            placeholder: "Роль",
            "search-without-refresh": "",
            loading: _ctx.state.roles.is_loading,
            failed: _ctx.state.roles.is_failed,
            options: _ctx.state.roles.list,
            "error-text": "При получении списка ролей произошла ошибка",
            value: _ctx.state.roleId,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.roleId) = $event))
          }, null, 8, ["loading", "failed", "options", "value"]),
          _createVNode(_component_the_select, {
            "can-deselect": "",
            class: "w-full mt-2",
            placeholder: "Статус пользователя",
            options: _ctx.USERS_STATUS_OPTIONS,
            value: _ctx.state.statusId,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.statusId) = $event))
          }, null, 8, ["options", "value"]),
          _createVNode(_component_the_select, {
            "can-deselect": "",
            class: "w-full mt-2",
            placeholder: "Компании",
            loading: _ctx.state.companies.is_loading,
            failed: _ctx.state.companies.is_failed,
            "error-text": "При получении списка произошла ошибка",
            options: _ctx.state.companies.list,
            value: _ctx.state.companyIds,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.companyIds) = $event)),
            onRefresh: _ctx.loadCompanies,
            multiselect: ""
          }, null, 8, ["loading", "failed", "options", "value", "onRefresh"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_button, {
            class: "second text small mr-3",
            disabled: _ctx.state.users.is_loading,
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.state.users.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.state.users.is_failed && !_ctx.state.users.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.users.is_loading,
              text: "При получении списка пользователей произошла ошибка",
              "error-message": _ctx.state.users.failure.error_state.message,
              "error-url": _ctx.state.users.failure.error_state.url,
              "error-status": _ctx.state.users.failure.error_state.status,
              onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadUsers(_ctx.state.users.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.state.users.is_loading,
              items: _ctx.state.users.list,
              pagination: "",
              "pagination-current-page": _ctx.state.users.pagination.current_page,
              "pagination-total-pages": _ctx.state.users.pagination.total_pages,
              onChangePage: _ctx.loadUsers
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_users_list_item, {
                  item: item,
                  onUpdate: _ctx.startUpdate,
                  onDelete: _ctx.startDelete,
                  onChangeStatus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadUsers(1))),
                  onAttach: _ctx.onStartAttach
                }, null, 8, ["item", "onUpdate", "onDelete", "onAttach"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}